import Header from './header.element.js';

export default Header;

Header.define('wje-header', Header);
